export default __webpack_public_path__ + "static/TaleFin_Logo_Plum_RGB_1600px-bc1e7f27d35b37f4e9df35bcfeb8d611.png";